/**
 * P4 / G13 (`ls-purge`) — purge all localStorage keys matching `/^admin_token_/`.
 * Includes `admin_token_dev` and per-tenant `admin_token_{code}`.
 *
 * Call sites: `endAdminSession`, boot (`AdminLsPurgeOnBoot`), failed-flip when present.
 */

/** Plan G13 / EXC-ADMIN-LS-COMPAT — exact key match. */
export const ADMIN_TOKEN_LS_KEY_RE = /^admin_token_/;

export function purgeAdminTokenLocalStorage(): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key !== null && ADMIN_TOKEN_LS_KEY_RE.test(key)) {
        toRemove.push(key);
      }
    }
    for (const key of toRemove) {
      localStorage.removeItem(key);
    }
  } catch {
    // ignore quota / private mode
  }
}

/** Boot once — P4 Pass (1): purge on boot + session-end. */
export function purgeAdminTokenLocalStorageOnBoot(): void {
  purgeAdminTokenLocalStorage();
}
